<script>
	export let title = 'Section Title';
	export let color = 'grey';
</script>

<style>
	.flex {
		margin:0.2rem 0;
		width:calc(100% - 1em);
	}
	.line {
		height:0.15em;
		width:100%;
		background:var(--custom);
	}
	span {
		text-align: center;
		font-style:normal;
		color:var(--custom);
		font-weight:400;
		display:inline-block;
		white-space: nowrap;
		padding:0 1em;
	}
</style>

<div class="flex" style="--custom:var(--{color})">
	<div class="line"></div>
	<span class="text-ui">{title}</span>
	<div class="line"></div>
</div>
